import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { DiscountForm } from "@modules/discounts/components/DiscountForm";
import { useDiscountCreateForm } from "./controller";

export const DiscountCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useDiscountCreateForm();

  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <DiscountForm />
      </FormProvider>
    </Create>
  );
});
